import { REQUEST_STATUS } from '../../../constants/request'

export function getRequestStatusSelectOption(status, t) {
  const statusItem = REQUEST_STATUS[status.id]

  return {
    ...status,
    backgroundColor: statusItem.backgroundColor,
    label: t(statusItem.text),
    textColor: statusItem.textColor,
    value: status.id,
  }
}

export function getRequestStatusSelectOptions(options, t) {
  return options.map(option => getRequestStatusSelectOption(option, t))
}

export function getRequestStatusSelectValue(status, t) {
  return status ? getRequestStatusSelectOption(status, t) : null
}
